import React from 'react'
import {
  EmailShareButton,
  FacebookShareButton,
  TwitterShareButton,
  FacebookIcon,
  TwitterIcon,
  EmailIcon,
} from 'react-share'
import Box from '@material-ui/core/Box'
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined'
import LinkOutlinedIcon from '@material-ui/icons/LinkOutlined'
import CopyTextButton from '../copy-text-button'
import { useStyles } from './styles'
import Typography from '@material-ui/core/Typography'
import CopyTextLineEllipsis from '../copy-text-line-ellipsis'

const ShareBox = ({ url, title, bookingType, showBookingUrl }) => {
  const accessCode = bookingType?.accessCode
  let subtitle = showBookingUrl
    ? 'Share your schedule page with your students.'
    : 'Share this booking type with your students.'
  subtitle = accessCode
    ? `${subtitle} Be sure to include the access code.`
    : subtitle

  const classes = useStyles()
  return (
    <Box>
      <Typography variant="body1" color="textSecondary">
        {subtitle}
      </Typography>
      <br />
      {showBookingUrl && <CopyTextLineEllipsis text={url} />}
      <Box display="flex" justifyContent="center" mb={4} mt={2}>
        <FacebookShareButton
          url={url}
          quote={title}
          className={classes.shareRow}
        >
          <FacebookIcon size={40} round />
        </FacebookShareButton>
        <TwitterShareButton
          url={url}
          title={title}
          className={classes.shareRow}
        >
          <TwitterIcon size={40} round />
        </TwitterShareButton>
        <EmailShareButton
          url={url}
          subject={title}
          className={classes.shareRow}
        >
          <EmailIcon size={40} round />
        </EmailShareButton>
        <CopyTextButton value={url} className={classes.shareRow}>
          <LinkOutlinedIcon className={classes.linkButton} />
        </CopyTextButton>
      </Box>
      {accessCode && (
        <Box textAlign="center" mb={2}>
          <Typography variant="body2" color="textSecondary">
            Required Access Code:
          </Typography>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            mb={2}
          >
            <h3>{accessCode}</h3>
            <CopyTextButton
              value={accessCode}
              className={classes.shareRow}
              classes={{
                label: classes.copyButton,
              }}
              startIcon={<FileCopyOutlinedIcon />}
            ></CopyTextButton>
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default ShareBox
